module.exports = __webpack_public_path__ + "img/tiger-machine-handle.1291b55b.svg";